import { useEffect, useRef } from 'react';
import { useTheme } from '../context/ThemeContext';
import Chart from '../chart';

export default function FaultShutdownsChart({ data = [] }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);
  const { theme } = useTheme();

  useEffect(() => {
    const ctx = canvasRef.current?.getContext('2d');
    if (!ctx) return;

    const labels = data.map((d) => d.equipment);
    const values = data.map((d) => d.shutdown_count);

    chartRef.current?.destroy();
    chartRef.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels,
        datasets: [
          {
            data: values,
            borderRadius: 18,
            borderSkipped: false,
            backgroundColor: (context) => {
              const chart = context.chart;
              const { ctx, chartArea } = chart;
              if (!chartArea) {
                return theme === 'dark'
                  ? 'rgba(125, 211, 252, 0.8)'
                  : 'rgba(14, 165, 233, 0.8)';
              }
              const gradient = ctx.createLinearGradient(
                chartArea.left,
                chartArea.top,
                chartArea.left,
                chartArea.bottom
              );
              gradient.addColorStop(0, 'rgba(56,189,248,0.95)');
              gradient.addColorStop(0.6, 'rgba(45,212,191,0.85)');
              gradient.addColorStop(1, 'rgba(16,185,129,0.8)');
              return gradient;
            },
            hoverBackgroundColor: 'rgba(56,189,248,1)',
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: { padding: { top: 24, bottom: 8, right: 8, left: 8 } },
        animation: { duration: 600, easing: 'easeOutQuart' },
        plugins: {
          legend: { display: false },
          datalabels: {
            anchor: 'end',
            align: 'end',
            offset: 4,
            font: { weight: 600 },
            color: theme === 'dark' ? '#f8fafc' : '#0f172a',
          },
          tooltip: {
            backgroundColor: 'rgba(15,23,42,0.9)',
            titleColor: '#e2e8f0',
            bodyColor: '#cbd5f5',
            borderColor: 'rgba(148,163,184,0.2)',
            borderWidth: 1,
            displayColors: false,
            callbacks: {
              label: (context) => `${context.formattedValue} shutdowns`,
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: theme === 'dark' ? '#e2e8f0' : '#1f2937',
              autoSkip: false,
              maxRotation: 45,
              minRotation: 45,
              font: { weight: 600 },
            },
            grid: { display: false },
          },
          y: {
            beginAtZero: true,
            ticks: {
              color: theme === 'dark' ? '#cbd5f5' : '#1f2937',
              font: { weight: 600 },
            },
            grid: {
              color: theme === 'dark' ? 'rgba(148,163,184,0.15)' : 'rgba(148,163,184,0.2)',
              drawBorder: false,
            },
          },
        },
      },
    });

    return () => {
      chartRef.current?.destroy();
      chartRef.current = null;
    };
  }, [data, theme]);

  return (
    <div className="relative w-full h-full">
      <canvas
        ref={canvasRef}
        className="absolute inset-0 w-full h-full"
      />
    </div>
  );
}

